import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { getRangeFromToLabel } from '@/bundles/GroupFilters/helpers/formatters/range/getRangeFromToLabel';
import { Nullable } from '@/utils/types';
import { formatCurrencyShowDecimalWhenExist } from '@/utils/filters';
import { SalePriceEnum, SalePriceEnumLabels } from '@/bundles/GroupFilters/enums/SalePriceEnum';

export const getSalePriceRangeFormattedValue = (value: [Nullable<number>, Nullable<number>], selectedUnit?: SalePriceEnum): string => {
  const isValuePresentInArray = value.some((v) => isValuePresent(v));
  const selectedUnitLabel = selectedUnit ? `(${SalePriceEnumLabels[selectedUnit]})` : '';

  return isValuePresentInArray ? `${getRangeFromToLabel(value.map((item) => {
    return isValuePresent(item) ? formatCurrencyShowDecimalWhenExist(item) : null;
  }))} ${selectedUnitLabel}`.trim() : '';
}
